import { api } from "../component/constent";

// ============================================================
// GET ALL LABOUR RATES
// ============================================================

export const getLabourRateList = () => {

    return api.get(    "/entry/labourrate"
    );

};


// ============================================================
// GET SINGLE SHOP
// ============================================================

export const getLabourRateByShop = (shop) => {

    return api.get(
        `/entry/labourrate/${shop}`
    );

};


// ============================================================
// UPDATE LABOUR RATE
// ============================================================

export const updateLabourRate = (data) => {

    return api.put(
        "/entry/labourrate",
        data
    );

};